<template>

                
              
                <svg viewBox="-10 -60 150 200" xmlns="http://www.w3.org/2000/svg">
                  <circle
                    :stroke-dasharray="circumference"
                    :stroke-dashoffset="offset"
                    cx="50"
                    cy="50"
                    r="55"
                    class="circle"
                    stroke="none"
                    fill="#fff"
                  />
                  <text
                    x="50"
                    y="50"
                    text-anchor="middle"
                    dominant-baseline="central"
                    class="percentage"
                  >
                    {{ percentage1 }}%
                  </text>
                </svg>
            
</template>

<script>
export default {
  props: {
    percentage2: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      percentage1: 0,
      circumference: 2 * Math.PI * 45,
      offset: 2 * Math.PI * 45,
    };
  },
  watch: {
    percentage2(newVal) {
      this.animateCircle(newVal);
    }
  },
  methods: {
    animateCircle(percentage1) {
        console.log(percentage1)
        let progress = 0;
      const interval = setInterval(() => {
        progress += 1;
        this.percentage1 = Math.min(progress, percentage1);
        this.offset =
          this.circumference - (this.percentage1 / 100) * this.circumference;
        if (progress >= percentage1) {
          clearInterval(interval);
        }
      }, 20);
    }
  }
};
</script>

<style>
.circle {
  fill: #fff;
  stroke: none;
  stroke-width: 0;
  stroke-linecap: round;
  stroke-dasharray: 283;
}
.percentage {
  font-size: 25px;
  font-weight: bold;
  fill: #1e90ff;
}
</style>